import { Link } from 'react-router-dom';
import { ArrowLeft, LogOut } from 'lucide-react';
import {
  AppShell,
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Spinner,
} from '../../components/index.js';
import { useAuth } from '../../lib/auth-context.js';

export function Profile() {
  const { me, loading, signOut } = useAuth();

  return (
    <AppShell>
      <div className="max-w-3xl mx-auto px-8 py-10 space-y-6">
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-1 text-sm text-text-secondary hover:text-text-primary"
        >
          <ArrowLeft className="size-4" aria-hidden />
          Back to dashboard
        </Link>
        <header>
          <h1 className="text-3xl font-bold text-text-primary">Profile</h1>
        </header>

        {loading && (
          <div className="flex justify-center py-10">
            <Spinner size="lg" />
          </div>
        )}

        {!loading && me && (
          <Card>
            <CardHeader title="Account" description="Your TAS Portal profile." />
            <CardBody>
              <dl className="grid gap-3 sm:grid-cols-2">
                <div>
                  <dt className="text-sm text-text-secondary">Name</dt>
                  <dd className="text-base text-text-primary">{me.name || '—'}</dd>
                </div>
                <div>
                  <dt className="text-sm text-text-secondary">Email</dt>
                  <dd className="text-base text-text-primary">{me.email}</dd>
                </div>
                <div>
                  <dt className="text-sm text-text-secondary">Role</dt>
                  <dd>
                    <Badge>{me.role}</Badge>
                  </dd>
                </div>
                <div>
                  <dt className="text-sm text-text-secondary">Member since</dt>
                  <dd className="text-base text-text-primary">
                    {new Date(me.createdAt).toLocaleDateString()}
                  </dd>
                </div>
              </dl>
            </CardBody>
          </Card>
        )}

        <Card>
          <CardHeader title="Session" description="Sign out of TAS Portal on this device." />
          <CardBody>
            <Button
              variant="secondary"
              onClick={() => signOut()}
              leftIcon={<LogOut className="size-4" aria-hidden />}
            >
              Sign out
            </Button>
          </CardBody>
        </Card>
      </div>
    </AppShell>
  );
}
